import React, { useEffect, useRef, useState } from "react";
import WrapperCard from "../../../component-lib/Atoms/card/EventEHRWrapperCard";
import useDeviceType from "../../../custom-hooks/DeviceType";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import Button from "../../../component-lib/Molecules/button/Button";
import {
  DownloadIcon,
  plusIcon,
  rightDirectionBlackIcon,
  searchIcon,
} from "../../../assets";
import EventEHRTabs from "../../../component-lib/Molecules/tabs/EventEHRTabs";
import Table from "../../../component-lib/Organisms/table/EventEHRTable";
import MenuDropdown from "../../../component-lib/Molecules/menuDropdown/MenuDropdown";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import EventEHRProfileDetailsCard from "../../../component-lib/show-profile-details-card/EventEHRProfileDetailsCard";
import SearchSelectDropdown from "../../../component-lib/Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import SelectDropdown from "../../../component-lib/Atoms/Select/Select";
import { INVENTORY_TYPE_OPTIONS } from "../../reports-screen/ReportConstants";
import useHasOverflow from "../../../custom-hooks/HasOverflow";
import EventEHRSwitchButton from "../../../component-lib/Molecules/switch-button/EventEHRSwitchButton";
import EventEHRToggleTabButton from "../../../component-lib/Molecules/toggle-tab-button/EventEHRToggleTabButton";
import {
  destructStatusData,
  getStatusBackground,
  getStatusDotColor,
  getStatusTextColor,
} from "../../../utils/statusConstants";
import AddDepartmentDialog from "../dialogs/AddNewDepartmentDialog";
import AddNewRoomDialog from "../dialogs/AddNewRoomDialog";
import AddNewPatientDialog from "../dialogs/AddNewPatientDialog";
import AddProviderUserDialog from "../dialogs/AddProviderUserDialog";
import ProviderProfileDialog from "./dialogs/ProviderProfileDialog";
import AddNewInventoryDialog from "../dialogs/AddNewInventoryDialog";
import ImportInventoryDialog from "../../inventory-screen/dialogs/ImportInventory";
import ImportResultsDialog from "../../inventory-screen/dialogs/ImportResultsDialog";
import ImportUsersDialog from "../../settings-screen/dialogs/ImportUsers";
import { importUsersResultsColumns } from "../../settings-screen/dialogs/importUsersResultsColumns";
import { useDispatch, useSelector } from "react-redux";
import {
  addDepartment,
  addNewFacilityUser,
  createFacilityInventory,
  deleteFacilityUser,
  deleteDepartment,
  getDepartmentList,
  getFacilityById,
  getFacilityInventoryList,
  getFacilityUserList,
  getPatientList,
  patchAddFacilityInventory,
  deleteFacilityInventory,
  postInventoryNotes,
  getInventoryNotesGroupedByIds,
  postBulkTransfer,
  patchDepartmentData,
  patchFacilityUser,
  sendFacilityUserInvitation,
  sendFacilityUserBulkInvitation,
  addRoom,
  getRoomList,
  patchRoomData,
  deleteRoom,
} from "../FacilityManagementSaga";
import FacilityManagementService from "../../../services/FacilityManagementService";
import {
  componentKey,
  setCloseCreatePatientDrawer,
  setCloseDepartmentDialog,
  setCloseFacilityInventoryAddData,
  setCloseUserDialog,
  setDeleteDepartmentResponse,
  setCloseRoomDialog,
  setGroupedNotesData,
  setCloseAddNotesDialog,
  setCloseSendBulkDialog,
} from "../FacilityManagementSlice";
import {
  getCampDetails,
  getDepartmentRowData,
  getFacilityUserData,
  getHeadingTitle,
  getHeadingViewTitle,
  getInventoryListData,
  getPatientRowData,
  getRoomRowData,
} from "../constants";
import ViewFacilityInventoryDialog from "./dialogs/ViewFacilityInventoryDailog";
import AdjustInventoryDialog from "./dialogs/AdjustInventoryDialog";
import SendInventoryDialog from "./dialogs/SendInventoryDialog";
import moment from "moment";
import UserViewDialog from "./dialogs/UserViewDialog";
import TooltipForTable from "../../../component-lib/Molecules/tooltip/TooltipForTable";
import ViewFacilityPatientDialog from "./dialogs/ViewFacilityPatientDialog";
import { handleImportData } from "../../../utils/handleImportData ";
import EventEHRConfirmationDialog from "../../../component-lib/Molecules/confimation-dialog/EventEHRConfirmationDialog";
import DeleteFacilityConfirmationDialog from "../../dashboard-screen/dialogs/DeleteFacilityConfirmationDialog";
const FacilityDetailsScreen = () => {
  const {
    baseCampDetails,
    closeDepartmentDialog,
    departmentList,
    patientListData,
    inventoriesList,
    closeCreatePatientDrawer,
    closeFacilityInventoryData,
    closeUserDialog,
    facilityUserList,
    deleteDepartmentResponse,
    roomList,
    closeRoomDialog,
    groupedNotesData,
    closeAddNotesDialog,
    closeSendBulkDialog,
  } = useSelector((state: any) => state[componentKey]);
  const { facilityId } = useParams();
  const dispatch = useDispatch();
  // YOU CAN USE THIS TYPE FOR BUTTON
  const commonButtonStyle = {
    paddingTop: "6px",
    paddingBottom: "6px",
    minWidth: "155px",
  };

  const [searchParams] = useSearchParams();
  const defaultSelectedPatient = searchParams.get("selectedPatient"); // Replace 'yourParam' with your parameter name

  const navigate = useNavigate();
  const deviceType = useDeviceType();
  const divRef = useRef<HTMLDivElement>(null);
  const hasOverflow = useHasOverflow(divRef);
  // THIS IS THE SELECTED TAB USE STATE
  const [selectedTab, setSelectedTab] = useState(
    defaultSelectedPatient === "patient" ? "patient" : "department",
  );

  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [rowPerPage, setRowPerPage] = useState("10");
  const [searchedValue, setSearchValue] = useState<string>("");
  const [pageNumber, setPageNumber] = useState(1);
  const [categoryType, setCategoryType] = useState("");
  const [defaultDepartmentDataRow, setDefaultDepartmentDataRow] = useState<any>(
    {},
  );
  // OPEN ADD NEW ROOM DIALOG + edit row
  const [openAddNewRoomDialog, setOpenAddNewRoomDialog] = useState(false);
  const [defaultRoomDataRow, setDefaultRoomDataRow] = useState<any>({});
  // DELETE ROOM CONFIRMATION
  const [openDeleteInventoryConfirmation, setOpenDeleteInventoryConfirmation] =
    useState(false);
  const [selectedInventoryToDelete, setSelectedInventoryToDelete] =
    useState<any>(null);
  const [openDeleteRoomConfirmation, setOpenDeleteRoomConfirmation] =
    useState(false);
  const [selectedRoomToDelete, setSelectedRoomToDelete] = useState<any>(null);
  //VIEW DIALOG FROM PATIENT LIST FOR FACILITY
  const [openPatientListDialog, setOpenPatientListDialog] = useState({
    isOpen: false,
    defaultData: {},
  });
  //VIEW DIALOG FROM INVENTORY LIST FOR FACILITY
  const [openViewInventoryListDialog, setOpenViewInventoryListDialog] =
    useState(false);
  const [defaultDataForViewInventoryList, setDefaultDataForViewInventoryList] =
    useState();
  //EDIT DIALOG FROM INVENTORY LIST FOR FACILITY
  const [defaultInventoryData, setDefaultInventoryData] = useState<any>({});

  // ADJUST INVENTORY DIALOG
  const [openAdjustDialog, setOpenAdjustDialog] = useState(false);
  const [defaultDataForAdjust, setDefaultDataForAdjust] = useState<any>();

  // SEND / TRANSFER INVENTORY (single + bulk)
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [openSendDialog, setOpenSendDialog] = useState(false);
  const [transferItems, setTransferItems] = useState<any[]>([]);
  const [isSingleTransfer, setIsSingleTransfer] = useState(false);
  // Bumped to remount the inventory table and clear its selection after a transfer.
  const [inventoryTableKey, setInventoryTableKey] = useState(0);

  //Data Store For User Provider And Staff data & //OPEN VIEW DIALOG FOR USER AS PROVIDER AND STAFF
  const [openViewUserDialog, setOpenViewUserDialog] = useState(false);
  const [defaultDataForUser, setDefaultDataForUser] = useState<any>({});

  // OPEN ADD NEW DEPARTMENT DIALOG
  const [openAddNewDepartmentDialog, setOpenAddNewDepartmentDialog] =
    useState(false);

  // OPEN ADD NEW PATIENT DIALOG
  const [openAddNewPatientDialog, setOpenAddNewPatientDialog] = useState(false);

  // OPEN ADD NEW INVENTORY DIALOG
  const [openAddNewInventoryDialog, setOpenAddNewInventoryDialog] =
    useState(false);

  // OPEN IMPORT INVENTORY DIALOG
  const [openImportInventoryDialog, setOpenImportInventoryDialog] =
    useState(false);

  // OPEN IMPORT USERS DIALOG
  const [openImportUsersDialog, setOpenImportUsersDialog] = useState(false);

  // IMPORT USERS STATES (kept separate from the inventory import states)
  const [isImportingUsers, setIsImportingUsers] = useState(false);
  const [importUsersMessage, setImportUsersMessage] = useState<string | null>(
    null,
  );
  const [openImportUsersResultsDialog, setOpenImportUsersResultsDialog] =
    useState(false);
  const [importUsersResults, setImportUsersResults] = useState<{
    summary: {
      totalRecords: number;
      validRecords: number;
      invalidRecords: number;
      createdInventory: number;
      totalProcessed: number;
    };
    valid: Record<string, unknown>[];
    invalid: {
      index: number;
      reason: string;
      row: Record<string, unknown>;
    }[];
    message: string;
  } | null>(null);

  // IMPORT INVENTORY STATES
  const [isImporting, setIsImporting] = useState(false);
  const [importMessage, setImportMessage] = useState<string | null>(null);
  const [openImportResultsDialog, setOpenImportResultsDialog] = useState(false);
  const [importResults, setImportResults] = useState<{
    summary: {
      totalRecords: number;
      validRecords: number;
      invalidRecords: number;
      createdInventory: number;
      totalProcessed: number;
    };
    valid: Record<string, unknown>[];
    invalid: {
      index: number;
      reason: string;
      row: Record<string, unknown>;
    }[];
    message: string;
  } | null>(null);

  // OPEN ADD PROVIDER USER DIALOG
  const [openAddProviderUserDialog, setOpenAddProviderUserDialog] =
    useState(false);

  // THIS IS THE STATE TO SWITCH TOGGLEpatchFacilityData INSIDE USER TAB
  const [selectedTabForUser, setSelectedTabForUser] = useState("Provider");

  // BULK SEND-INVITATION SELECTION STATE (independent per sub-tab)
  const [selectedStaffRows, setSelectedStaffRows] = useState<any[]>([]);
  const [selectedProviderRows, setSelectedProviderRows] = useState<any[]>([]);

  // OPEN ADD PROVIDER PROFILE DIALOG
  const [openAddProviderProfileDialog, setOpenAddProviderProfileDialog] =
    useState(false);

  // DELETE USER CONFIRMATION DIALOG STATES
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  // DELETE DEPARTMENT STATES
  const [
    openDeleteDepartmentConfirmationDialog,
    setOpenDeleteDepartmentConfirmationDialog,
  ] = useState(false);
  const [deleteDepartmentData, setDeleteDepartmentData] = useState<any>(null);
  const [deleteDepartmentResponseData, setDeleteDepartmentResponseData] =
    useState<any>(null);

  const headingTitle = getHeadingTitle(selectedTabForUser, defaultDataForUser);
  const headingTitleForView = getHeadingViewTitle(
    selectedTabForUser,
    defaultDataForUser,
  );
  const departmentTabRowData = getDepartmentRowData(departmentList);

  // ROOM TAB ROW DATA
  const roomTabRowData = getRoomRowData(roomList);

  // ROOM TAB COLUMNS
  const roomTabColumns = [
    {
      field: "roomName",
      label: <div>Room Name</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal common-text-ellipse-style">
          {row?.roomName}
        </p>
      ),
    },
    {
      field: "roomNumber",
      label: <div>Room Number</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal common-text-ellipse-style">
          {row?.roomNumber}
        </p>
      ),
    },
    {
      field: "capacity",
      label: <div>Capacity</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal">{row?.capacity}</p>
      ),
    },
    {
      field: "currentOccupancy",
      label: <div>Current Occupancy</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal">{row?.currentOccupancy}</p>
      ),
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal">{row?.status}</p>
      ),
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => (
        <div className="flex items-center">
          <MenuDropdown
            options={[
              {
                label: "Edit Room",
                onClickCb: () => {
                  setDefaultRoomDataRow(row);
                  setOpenAddNewRoomDialog(true);
                },
              },
              {
                label: "Delete Room",
                onClickCb: () => {
                  setSelectedRoomToDelete(row);
                  setOpenDeleteRoomConfirmation(true);
                },
              },
            ]}
          />
        </div>
      ),
    },
  ];

  // PATIENT TAB ROW DATA
  const patientTabRowData = getPatientRowData(patientListData);

  // Inventory FACILITY LIST DATA
  const inventoryRowDataList = getInventoryListData(inventoriesList);

  // USER PROVIDER TAB ROW DATA
  const userProviderTabRowData = getFacilityUserData(facilityUserList);

  // USER STAFF TAB ROW DATA
  const userStaffTabRowData = getFacilityUserData(facilityUserList);

  // CAMP lOCATION  DATA
  const campLocationDetails = getCampDetails(baseCampDetails);

  // HANDLE DELETE DEPARTMENT
  const handleDeleteDepartment = (row: any) => {
    setDeleteDepartmentData(row);
    setDeleteDepartmentResponseData(null);
    // Clear previous response
    dispatch(setDeleteDepartmentResponse(null));

    // First call with force=false
    dispatch(
      deleteDepartment({
        departmentId: row?.id,
        force: false,
      }),
    );
  };

  // DEPARTMENT COLUMN DATA
  const departmentTabColumns = [
    {
      field: "departmentId",
      label: <div>Department ID</div>,
      renderLogic: (row: any) => {
        return (
          // <p className=" text-primary-main font-normal font-weight-500 common-text-ellipse-style ">
          <p className=" text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.departmentId}
          </p>
        );
      },
    },
    {
      field: "departmentName",
      label: <div>Department Name</div>,
      renderLogic: (row: any) => {
        return (
          <p className=" text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.departmentName}
          </p>
        );
      },
    },
    {
      field: "departmentAdmin",
      label: <div>Department Admin</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.departmentAdmin}
          </p>
        );
      },
    },
    {
      field: "contactNumber",
      label: <div>Contact Number</div>,
      renderLogic: (row: any) => {
        return (
          <p
            style={{
              width: "auto",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            className="text-neutral-90 cursor-pointer"
            onClick={() => {}}
          >
            {row?.contactNumber}
          </p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        const status =
          row?.status === "Active"
            ? true
            : row?.status === "InActive"
              ? false
              : false;
        return (
          <p className="text-neutral-90 font-normal">
            <EventEHRSwitchButton
              checked={status}
              onChange={() => {
                const apiPayload = {
                  payload: {
                    status: status ? "InActive" : "Active",
                  },
                  departmentId: row?.id,
                };
                dispatch(patchDepartmentData(apiPayload));
              }}
            />
          </p>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "Edit Department",
                    onClickCb: () => {
                      setOpenAddNewDepartmentDialog(true);
                      setDefaultDepartmentDataRow(row);

                      // navigate(`/patient/${row}`);
                    },
                  },
                  {
                    label: "Delete Department",
                    onClickCb: () => {
                      handleDeleteDepartment(row);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // PATIENT TAB COLUMN DATA
  const patientTabColumns = [
    {
      field: "bsaId",
      label: <div>BSA ID</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.bsaId}</p>;
      },
    },

    {
      field: "patientName",
      label: <div>Patient Name</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.patientName}</p>
        );
      },
    },
    // {
    //   field: "gender",
    //   label: <div>Gender</div>,
    //   renderLogic: (row: any) => {
    //     return <p className="text-neutral-90 font-normal">{row?.gender}</p>;
    //   },
    // },
    {
      field: "gender",
      label: <div>Gender</div>,
      renderLogic: (row: any) => {
        const formattedGender = row?.gender
          ? row.gender.charAt(0).toUpperCase() +
            row.gender.slice(1).toLowerCase()
          : "";

        return <p className="text-neutral-90 font-normal">{formattedGender}</p>;
      },
    },
    {
      field: "visitType",
      label: <div>Visit Type</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.visitType}</p>;
      },
    },
    {
      field: "Status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.status),
                background: getStatusBackground(row?.status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.status),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.status)}
            </span>
          </div>
        );
      },
    },
    {
      field: "contactNumber",
      label: <div>Contact Number</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.contactNo}</p>;
      },
    },
    {
      field: "emergencyContact",
      label: <div>Emergency Contact</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.emergencyContact}</p>
        );
      },
    },

    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Patient",
                    onClickCb: () => {
                      setOpenPatientListDialog({
                        isOpen: true,
                        defaultData: row,
                      });
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // INVENTORY TAB COLUMN DATA
  const inventoryTabColumns = [
    {
      field: "itemName",
      label: <div>Item Name</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.itemName}</p>;
      },
    },
    {
      field: "category",
      label: <div>Category</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.category}</p>;
      },
    },
    {
      field: "stockLevel",
      label: <div>Stock Level</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.stockLevel}</p>;
      },
    },
    {
      field: "reorderPoint",
      label: <div>Reorder Point</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.reorderPoint}</p>
        );
      },
    },
    {
      field: "order",
      label: <div>Ordered Quantity</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.order}</p>;
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.status),
                background: getStatusBackground(row?.status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.status),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.status)}
            </span>
          </div>
        );
      },
    },
    {
      field: "status",
      label: <div>Order Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.orderStatus),
                background: getStatusBackground(row?.orderStatus),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.orderStatus),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.orderStatus)}
            </span>
          </div>
        );
      },
    },
    {
      field: "expirationDate",
      label: <div>Expiration Date</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.expirationDate}</p>
        );
      },
    },

    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        const actions = [
          {
            label: "View Inventory",
            onClickCb: () => {
              setDefaultDataForViewInventoryList(row);
              dispatch(getInventoryNotesGroupedByIds({ ids: row?.id }));
              setOpenViewInventoryListDialog(true);
            },
          },
          {
            label: "Adjust Inventory",
            disabled: Number(row?.stockLevel) === 0,
            onClickCb: () => {
              setDefaultDataForAdjust(row);
              setOpenAdjustDialog(true);
            },
          },
          {
            label: "Send Inventory",
            disabled: Number(row?.stockLevel) === 0,
            onClickCb: () => {
              setTransferItems([row]);
              setIsSingleTransfer(true);
              setOpenSendDialog(true);
            },
          },
          {
            label: "Delete Inventory",
            onClickCb: () => {
              setSelectedInventoryToDelete(row);
              setOpenDeleteInventoryConfirmation(true);
            },
          },
        ];
        if (row?.orderStatus === "Delivered") {
          actions.push({
            label: "Re-Order Inventory",
            onClickCb: () => {
              setOpenAddNewInventoryDialog(true);
              setDefaultInventoryData(row);
            },
          });
        }
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown options={actions} />
            </div>
          </>
        );
      },
    },
  ];

  // USER STAFF TAB COLUMN DATA
  const userStaffTabColumns = [
    {
      field: "staffID",
      label: <div>BSA ID</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.bsaId}</p>;
      },
    },
    {
      field: "name",
      label: <div>Staff Name</div>,
      renderLogic: (row: any) => {
        return (
          <p
            className="text-neutral-90 font-normal"
            onClick={() => {
              // navigate("/user-profile", { state: { title: "Staff Profile" } });
            }}
          >
            {row?.providerName}
          </p>
        );
      },
    },
    {
      field: "departments",
      label: <div>Departments</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">
            {/* {row?.departments} */}
            <TooltipForTable label={row?.departmentName} />
          </p>
        );
      },
    },
    {
      field: "role",
      label: <div>Role</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.role}</p>;
      },
    },
    {
      field: "email",
      label: <div>Email</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.email}</p>;
      },
    },
    {
      field: "contactNumber",
      label: <div>Contact Number</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.contactNumber}</p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any, index: any) => {
        const status =
          row?.status === "Active"
            ? true
            : row?.status === "InActive"
              ? false
              : false;
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <EventEHRSwitchButton
              checked={status}
              onChange={() => {
                const payload = {
                  payload: {
                    status: status ? "InActive" : "Active",
                  },
                  id: row?.id,
                };
                dispatch(patchFacilityUser(payload));
              }}
            />
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Profile",
                    onClickCb: () => handleOpenDialog(row),
                  },
                  {
                    label: "Edit Profile",
                    onClickCb: () => {
                      setDefaultDataForUser(row);
                      setOpenAddProviderProfileDialog(true);
                      // navigate(`/patient/${row}`);
                    },
                  },
                  {
                    label: "Send Invitation",
                    onClickCb: () => {
                      dispatch(sendFacilityUserInvitation({ id: row?.id }));
                    },
                  },
                  {
                    label: "Delete Profile",
                    onClickCb: () => {
                      setSelectedUserId(row?.id);
                      setOpenConfirmationDialog(true);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // USER PROVIDER TAB COLUMN DATA
  const userProviderTabColumns = [
    {
      field: "BSA ID",
      label: <div>BSA ID</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.bsaId}</p>;
      },
    },
    {
      field: "providerName",
      label: <div>Provider Name</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal" onClick={() => {}}>
            {row?.providerName}
          </p>
        );
      },
    },
    {
      field: "departments",
      label: <div>Departments</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">
            {/* {row?.departments} */}
            <TooltipForTable label={row?.departmentName} />
          </p>
        );
      },
    },
    {
      field: "role",
      label: <div>Role</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.role}</p>;
      },
    },
    {
      field: "email",
      label: <div>Email</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.email}</p>;
      },
    },
    {
      field: "contactNumber",
      label: <div>Contact Number</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.contactNumber}</p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        const status =
          row?.status === "Active"
            ? true
            : row?.status === "InActive"
              ? false
              : false;
        return (
          <p className="text-neutral-90 font-normal">
            <EventEHRSwitchButton
              checked={status}
              onChange={() => {
                const payload = {
                  payload: {
                    status: status ? "InActive" : "Active",
                  },
                  id: row?.id,
                };
                dispatch(patchFacilityUser(payload));
              }}
            />
          </p>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Profile",
                    onClickCb: () => handleOpenDialog(row),
                  },
                  {
                    label: "Edit Profile",
                    onClickCb: () => {
                      setDefaultDataForUser(row);
                      setOpenAddProviderProfileDialog(true);
                      // navigate(`/patient/${row}`);
                    },
                  },
                  {
                    label: "Send Invitation",
                    onClickCb: () => {
                      dispatch(sendFacilityUserInvitation({ id: row?.id }));
                    },
                  },
                  {
                    label: "Delete Profile",
                    onClickCb: () => {
                      setSelectedUserId(row?.id);
                      setOpenConfirmationDialog(true);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // GET CAMP DETAILS BY ID
  useEffect(() => {
    dispatch(getFacilityById(facilityId));
  }, []);

  // MADE TAB-WISE API CALL
  useEffect(() => {
    switch (selectedTab) {
      case "department":
        getDepartments();
        break;
      case "patient":
        getPatients();
        break;
      case "inventoryList":
        getInventoriesList();
        break;
      case "user":
        getUsersList();
        break;
      case "room":
        getRooms();
        break;
    }
  }, [
    selectedTab,
    pageNumber,
    rowPerPage,
    searchedValue,
    selectedTabForUser,
    categoryType,
  ]);

  // Watch for delete department response
  useEffect(() => {
    if (deleteDepartmentResponse && deleteDepartmentData) {
      const responseData = deleteDepartmentResponse.data;
      const wasForceDelete = deleteDepartmentResponse.force === true;

      if (wasForceDelete) {
        // Force delete was called - check if it succeeded
        if (
          deleteDepartmentResponse.success === true ||
          responseData?.success === true
        ) {
          // Force delete succeeded, close dialog and refresh
          setOpenDeleteDepartmentConfirmationDialog(false);
          setDeleteDepartmentData(null);
          setDeleteDepartmentResponseData(null);
          dispatch(setDeleteDepartmentResponse(null));
          // Refresh department list
          getDepartments();
        }
      } else if (!wasForceDelete) {
        // First call (force=false) - always show confirmation dialog
        // Whether success is true or false, we show confirmation
        setDeleteDepartmentResponseData(responseData);
        setOpenDeleteDepartmentConfirmationDialog(true);
      }
    }
  }, [deleteDepartmentResponse, deleteDepartmentData]);

  // HANDLE DELETE DEPARTMENT CONFIRMATION
  const handleDeleteDepartmentConfirmation = (action: "cancel" | "delete") => {
    if (action === "cancel") {
      setOpenDeleteDepartmentConfirmationDialog(false);
      setDeleteDepartmentData(null);
      setDeleteDepartmentResponseData(null);
      dispatch(setDeleteDepartmentResponse(null));
      return;
    }

    // User confirmed deletion
    if (deleteDepartmentData) {
      // Clear previous response before new call
      dispatch(setDeleteDepartmentResponse(null));

      dispatch(
        deleteDepartment({
          departmentId: deleteDepartmentData?.id,
          force: true,
        }),
      );
    }
  };

  // CLOSE DEPARTMENT DIALOG
  useEffect(() => {
    if (closeDepartmentDialog) {
      getDepartments();
      dispatch(setCloseDepartmentDialog(false));
      setOpenAddNewDepartmentDialog(false);
    }

    if (closeCreatePatientDrawer) {
      getPatients();
      setOpenAddNewPatientDialog(false);
      dispatch(setCloseCreatePatientDrawer(false));
    }
    if (closeFacilityInventoryData) {
      getInventoriesList();
      setOpenAddNewInventoryDialog(false);
      dispatch(setCloseFacilityInventoryAddData(false));
    }
    if (closeUserDialog) {
      setOpenAddProviderProfileDialog(false);
      dispatch(setCloseUserDialog(false));
      getUsersList();
      setOpenConfirmationDialog(false); // Reset confirmation dialog
      setSelectedUserId(null); // Reset selected user ID
    }
    if (closeRoomDialog) {
      getRooms();
      dispatch(setCloseRoomDialog(false));
      setOpenAddNewRoomDialog(false);
    }
    if (closeAddNotesDialog) {
      dispatch(setCloseAddNotesDialog(false));
      setOpenAdjustDialog(false);
      getInventoriesList();
    }
    if (closeSendBulkDialog) {
      dispatch(setCloseSendBulkDialog(false));
      setOpenSendDialog(false);
      setInventoryTableKey((k) => k + 1);
      getInventoriesList();
    }
  }, [
    closeDepartmentDialog,
    closeCreatePatientDrawer,
    closeFacilityInventoryData,
    closeUserDialog,
    closeRoomDialog,
    closeAddNotesDialog,
    closeSendBulkDialog,
  ]);

  // GET DEPARTMENTS
  const getDepartments = () => {
    const payload = {
      facilityId: facilityId,
      pageNumber: pageNumber,
      limit: rowPerPage,
      name: searchedValue?.trim(),
    };
    dispatch(getDepartmentList(payload));
  };

  // GET ROOMS
  const getRooms = () => {
    const payload = {
      facilityId: facilityId,
      pageNumber: pageNumber,
      limit: rowPerPage,
      name: searchedValue?.trim(),
    };
    dispatch(getRoomList(payload));
  };

  // ADD / EDIT ROOM
  const handleAddRoomData = (data: any) => {
    try {
      const payload = {
        name: data?.roomName,
        roomNumber: data?.roomNumber,
        capacity: Number(data?.capacity),
        status: data?.status,
        facilityId: facilityId,
      };
      if (defaultRoomDataRow?.id) {
        dispatch(patchRoomData({ payload, roomId: defaultRoomDataRow?.id }));
      } else {
        dispatch(addRoom(payload));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // GET PATIENT LIST
  const getPatients = () => {
    const payload = {
      pageNumber: pageNumber,
      name: searchedValue?.trim(),
      limit: rowPerPage,
      facilityId: facilityId,
    };
    dispatch(getPatientList(payload));
  };

  // GET INVENTORY LIST
  const getInventoriesList = () => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      facilityId: facilityId,
      name: searchedValue?.trim(),
      type: categoryType || undefined,
    };
    dispatch(getFacilityInventoryList(payload));
  };

  // GET USETS
  const getUsersList = () => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      name: searchedValue?.trim(),
      facilityId: facilityId,
      type: selectedTabForUser
        ? selectedTabForUser?.toLocaleLowerCase()
        : undefined,
    };

    dispatch(getFacilityUserList(payload));
  };

  // ADD NEW DEPARTMENT API CALL HERE
  const handleAddDepartmentData = (data: any) => {
    try {
      const payload = {
        name: data?.departmentName,
        departmentId: data?.departmentId,
        adminName: data?.departmentAdmin,
        contactNumber: data?.departmentContactNo,
        facilityId: facilityId,
      };
      if (defaultDepartmentDataRow?.departmentId) {
        const apiPayload = {
          payload: {
            ...payload,
          },
          departmentId: defaultDepartmentDataRow?.id,
        };
        dispatch(patchDepartmentData(apiPayload));
      } else {
        dispatch(addDepartment(payload));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddProviderUser = (data: any) => {
    try {
      const payload = {
        bsaId: data?.bsaId,
        firstName: data?.firstName,
        lastName: data?.lastName,
        email: data?.email,
        facilityId: facilityId,
        roleId: data?.role,
        gender: data?.gender,
        contactNumber: data?.contactNumber,
        departmentIds: data?.department,
        type: selectedTabForUser
          ? selectedTabForUser.toLocaleLowerCase()
          : undefined,
      };
      if (defaultDataForUser?.bsaId) {
        const payload = {
          payload: {
            firstName: data?.firstName,
            lastName: data?.lastName,
            email: data?.email,
            roleId: data?.role,
            contactNumber: data?.contactNumber,
            gender: data?.gender,
            departmentIds: data?.department,
          },
          id: defaultDataForUser?.id,
        };
        dispatch(patchFacilityUser(payload));
      } else {
        dispatch(addNewFacilityUser(payload));
      }
    } catch (error) {
      console.log(error);
    }
  };

  //POST API FOR FACILITY INVENTORY DAILOG
  const handleFacilityInventoryData = (data: any) => {
    try {
      const payload = {
        facilityId: facilityId,
        itemId: data?.itemName,
        orderQuantity: Number(data?.quantity),
        threshold: Number(data?.thresholdValue),
        expirationDate: data?.expirationDate
          ? moment(data?.expirationDate)?.format("MM-DD-YYYY")
          : undefined,
      };

      // Check for required fields
      if (!payload.facilityId && !payload.itemId) {
        return;
      }

      if (defaultInventoryData && defaultInventoryData.id) {
        const apiPayload = {
          payload: {
            orderQuantity: Number(data?.quantity),
            threshold: Number(data?.thresholdValue),
            expirationDate: data?.expirationDate
              ? moment(data?.expirationDate)?.format("MM-DD-YYYY")
              : undefined,
            orderStatus: "Re-Order",
          },
          id: defaultInventoryData?.id,
        };

        dispatch(patchAddFacilityInventory(apiPayload));
      } else {
        dispatch(createFacilityInventory(payload));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ADJUST INVENTORY: save notes (backend debits stock)
  const adjustNotesHandler = (data: any) => {
    try {
      const payload = {
        id: defaultDataForAdjust?.id, // facilityOrderInventoryId
        notes: data?.notes?.map((note: any) => ({
          type: note?.type,
          quantity: Number(note?.quantity),
          comment: note?.comment || "",
        })),
      };
      dispatch(postInventoryNotes(payload));
    } catch (error) {
      console.log(error);
    }
  };

  // OPEN BULK TRANSFER (selected rows)
  const handleSendBulk = () => {
    setTransferItems(selectedRows);
    setIsSingleTransfer(false);
    setOpenSendDialog(true);
  };

  // TRANSFER selected rows to pharmacy / facility (per-item quantities)
  const handleTransferSend = (data: {
    target: string;
    facilityId: string;
    items: { id: string; quantity: number }[];
  }) => {
    const payload = {
      target: data?.target,
      facilityId: data?.target === "Facility" ? data?.facilityId : undefined,
      items: data?.items,
    };
    dispatch(postBulkTransfer(payload));
  };

  // HANDLE IMPORT INVENTORY DATA
  const handleImportFacilityData = async (formData: any) => {
    await handleImportData(formData, {
      service: FacilityManagementService.uploadFacilityInventoryFile,
      onRefresh: getInventoriesList,
      payloadExtras: { facilityId: facilityId },
      asyncMessage:
        "Facility import started successfully. You will be notified when it completes.",
      setIsImporting,
      setImportMessage,
      setImportResults,
      setOpenImportResultsDialog,
      setOpenImportInventoryDialog,
    });
  };

  // HANDLE IMPORT USERS DATA
  const handleImportUsersData = async (formData: Record<string, unknown>) => {
    await handleImportData(formData, {
      service: FacilityManagementService.uploadUsersFile,
      payloadExtras: {
        type: selectedTabForUser === "Staff" ? "staff" : "provider",
      },
      onRefresh: getUsersList,
      asyncMessage: "Users import started successfully.",
      setIsImporting: setIsImportingUsers,
      setImportMessage: setImportUsersMessage,
      setImportResults: setImportUsersResults,
      setOpenImportResultsDialog: setOpenImportUsersResultsDialog,
      setOpenImportInventoryDialog: setOpenImportUsersDialog,
    });
  };

  // HANDLE SEARCH CHANGE VALUE AND ADDED SOME DELAY
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNumber(1);

    const value = e.target.value;

    // CLEAR THE PREVIOUS TIMEOUT
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // SET A NEW TIMEOUT TO DELAY THE CALLBACK
    typingTimeoutRef.current = setTimeout(() => {
      setSearchValue(value?.trim());
    }, 500); // ADJUST DELAY AS NEEDED
  };

  //HANDLE THE VIEW DAILOG AS PROVIDER OR STAFF
  const handleOpenDialog = (row: Record<string, unknown>) => {
    setDefaultDataForUser(row);
    //setUserType(userType ? "Provider" : "Staff");
    setOpenViewUserDialog(true);
  };
  const isEdit = defaultInventoryData?.id;
  const check = isEdit && defaultInventoryData?.orderStatus !== "Delivered";

  return (
    <WrapperCard
      customClasses="m-3 p-3 pl-4 pr-4 flex-1 min-h-0 flex flex-col"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col flex-1 min-h-0 gap-3">
        {/*  SCREEN HEADER */}
        <div className={`flex items-center justify-between w-full`}>
          <div className="flex items-center gap-3">
            <img
              className="cursor-pointer"
              src={rightDirectionBlackIcon}
              alt="back-arrow"
              style={{ height: "12.5px" }}
              onClick={() => {
                navigate("/facility-management");
              }}
            />
            <Heading title={baseCampDetails?.facility?.name} />
          </div>
        </div>
        {/* MAIN CONTENT */}
        <div
          style={{
            overflow: "auto",
            flex: "1 1 0%",
            minHeight: 0,
            paddingRight: hasOverflow ? "7px" : "0",
          }}
          ref={divRef}
        >
          {/* IF LOCATION TAB SELECTED DETAILS CARD */}
          {
            <div className="mt-3">
              <EventEHRProfileDetailsCard
                patientDetails={campLocationDetails}
              />
            </div>
          }

          {/* TABS AND TAB WISE SCREEN HERE */}
          <div className="mt-3">
            {/* REUSABLE TAB COMPONENT */}
            <EventEHRTabs
              defaultSelectedValue={selectedTab}
              tabList={[
                { label: "Department", value: "department" },
                { label: "Patient", value: "patient" },
                { label: "Inventory List", value: "inventoryList" },
                { label: "User", value: "user" },
                { label: "Room", value: "room" },
              ]}
              onChangeTab={(tab) => {
                setPageNumber(1);
                setRowPerPage("10");
                setSearchValue("");
                setSelectedTabForUser("Provider");
                setSelectedTab(tab);
              }}
            />

            {/* IF SELECTED TAB IS DEPARTMENT */}
            {selectedTab === "department" && (
              <div
                className="mt-6 tab-main-content-height"
                // style={{ overflow: "auto" }}
              >
                <div className="flex flex-wrap items-center mb-4 gap-3 w-full xl:w-auto xl:justify-end">
                  {/* SEARCH DROPDOWN */}
                  {/* Width comes from MUI sx inside the component, so size it here. */}
                  <div className="w-full sm:w-[300px]">
                    <SearchSelectDropdown
                      freeSolo={true}
                      searchedValue={searchedValue}
                      onSearchValueChangeCb={(e) => handleChange(e)}
                      size="small"
                      label="Search by name, admin, contact number "
                      fullWidth="100%"
                      startIcon={
                        <img
                          alt="search-icon"
                          src={searchIcon}
                          width={"18px"}
                          height={"18px"}
                        />
                      }
                    />
                  </div>
                  {/* ADD DEPARTMENT BUTTON */}
                  <Button
                    startIcon={
                      <img
                        style={{ height: "23px" }}
                        src={plusIcon}
                        alt={"search"}
                        className="cursor-pointer w-[19px] h-[19px]"
                      />
                    }
                    label="Add Department"
                    variant="contained"
                    onClickCb={() => {
                      setDefaultDepartmentDataRow({});
                      setOpenAddNewDepartmentDialog(true);
                    }}
                    style={commonButtonStyle}
                  ></Button>
                </div>
                <Table
                  columns={departmentTabColumns}
                  rows={departmentTabRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: departmentList?.totalPages,
                    totalCount: departmentList?.total,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}

            {/* IF SELECTED TAB IS PATIENT */}
            {selectedTab === "patient" && (
              <div
                className="mt-6 tab-main-content-height"
                // style={{ overflow: "auto" }}
              >
                <div className="flex flex-wrap items-center mb-4 gap-3 w-full xl:w-auto xl:justify-end">
                  {/* SEARCH DROPDOWN */}
                  {/* Width comes from MUI sx inside the component, so size it here. */}
                  <div className="w-full sm:w-[300px]">
                    <SearchSelectDropdown
                      freeSolo={true}
                      searchedValue={searchedValue}
                      onSearchValueChangeCb={(e) => handleChange(e)}
                      size="small"
                      label="Search by Name, BSA ID, Contact number"
                      fullWidth="100%"
                      startIcon={
                        <img
                          alt="search-icon"
                          src={searchIcon}
                          width={"18px"}
                          height={"18px"}
                        />
                      }
                    />
                  </div>
                  {/* ADD PATIENT BUTTON */}
                  <Button
                    startIcon={
                      <img
                        style={{ height: "23px" }}
                        src={plusIcon}
                        alt={"search"}
                        className="cursor-pointer w-[19px] h-[19px]"
                      />
                    }
                    label="Add Patient"
                    variant="contained"
                    onClickCb={() => {
                      setDefaultInventoryData({});
                      setOpenAddNewPatientDialog(true);
                    }}
                    style={commonButtonStyle}
                  ></Button>
                </div>

                <Table
                  columns={patientTabColumns}
                  rows={patientTabRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: patientListData?.totalPages,
                    totalCount: patientListData?.total,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}

            {/* IF SELECTED TAB IS INVENTORY */}
            {selectedTab === "inventoryList" && (
              <div
                className="mt-6 tab-main-content-height"
                // style={{ overflow: "auto" }}
              >
                <div className="flex flex-wrap items-center mb-4 gap-3 w-full xl:w-auto xl:justify-end">
                  {/* CATEGORY FILTER */}
                  <div className="w-full sm:w-[180px]">
                    <SelectDropdown
                      name="categoryType"
                      displayEmpty={true}
                      value={categoryType}
                      options={INVENTORY_TYPE_OPTIONS}
                      onChangeCb={(e) => {
                        setPageNumber(1);
                        setCategoryType(e.target.value);
                      }}
                    />
                  </div>
                  {/* SEARCH DROPDOWN */}
                  {/* Width comes from MUI sx inside the component, so size it here. */}
                  <div className="w-full sm:w-[300px]">
                    <SearchSelectDropdown
                      freeSolo={true}
                      searchedValue={searchedValue}
                      onSearchValueChangeCb={(e) => handleChange(e)}
                      size="small"
                      label="Search by item name"
                      fullWidth="100%"
                      startIcon={
                        <img
                          alt="search-icon"
                          src={searchIcon}
                          width={"18px"}
                          height={"18px"}
                        />
                      }
                    />
                  </div>
                  {/* IMPORT INVENTORY BUTTON */}
                  <Button
                    startIcon={
                      <img
                        style={{ height: "23px", color: "#1976d2" }}
                        src={DownloadIcon}
                        alt={"Download"}
                        className="cursor-pointer  w-[19px] h-[19px]"
                      />
                    }
                    label="Import Inventory"
                    variant="outlined"
                    onClickCb={() => {
                      setOpenImportInventoryDialog(true);
                    }}
                    style={{
                      ...commonButtonStyle,
                      backgroundColor: "white",
                      border: "1px solid #1976d2",
                      color: "#1976d2",
                    }}
                  />
                  {/* SEND BULK INVENTORY BUTTON */}
                  <Button
                    label={
                      selectedRows?.length
                        ? `Send Bulk Inventory (${selectedRows.length})`
                        : "Send Bulk Inventory"
                    }
                    variant="outlined"
                    disabled={!selectedRows?.length}
                    onClickCb={handleSendBulk}
                    style={{ ...commonButtonStyle, minWidth: "180px" }}
                  ></Button>
                  {/* ADD INVENTORY BUTTON */}
                  <Button
                    startIcon={
                      <img
                        style={{ height: "23px" }}
                        src={plusIcon}
                        alt={"search"}
                        className="cursor-pointer w-[18px] h-[18px]"
                      />
                    }
                    label="Add Inventory"
                    variant="contained"
                    onClickCb={() => {
                      setDefaultInventoryData({});
                      setOpenAddNewInventoryDialog(true);
                    }}
                    style={commonButtonStyle}
                  ></Button>
                </div>

                <Table
                  key={inventoryTableKey}
                  columns={inventoryTabColumns}
                  rows={inventoryRowDataList}
                  selectProps={{
                    isSelectable: true,
                    isSelectAll: true,
                    selectIdentifier: "id",
                    onSelectAll: () => {},
                    onSelectRowsCb: (rows: any) => setSelectedRows(rows),
                  }}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: inventoriesList?.totalPages,
                    totalCount: inventoriesList?.totalCounts,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}

            {/* IF SELECTED TAB IS USER */}
            {selectedTab === "user" && (
              <div
                className="mt-6 tab-main-content-height"
                // style={{ overflow: "auto" }}
              >
                {/* FILTER PART */}
                <div className="flex justify-between items-center mb-4">
                  <EventEHRToggleTabButton
                    customWidth="206PX"
                    defaultSelected={selectedTabForUser}
                    tabs={["Provider", "Staff"]}
                    onToggle={(value) => {
                      setPageNumber(1);
                      setRowPerPage("10");
                      setSelectedTabForUser(value);

                      setSearchValue("");
                    }}
                  />
                  <div className="flex flex-wrap items-center gap-3 w-full xl:w-auto xl:justify-end">
                    {/* SEARCH DROPDOWN */}
                    {/* Width comes from MUI sx inside the component, so size it here. */}
                    <div className="w-full sm:w-[300px]">
                      <SearchSelectDropdown
                        freeSolo={true}
                        searchedValue={searchedValue}
                        onSearchValueChangeCb={(e) => handleChange(e)}
                        size="small"
                        label="Search by Name, BSA ID, Contact number"
                        fullWidth="100%"
                        startIcon={
                          <img
                            alt="search-icon"
                            src={searchIcon}
                            width={"18px"}
                            height={"18px"}
                          />
                        }
                      />
                    </div>

                    {(() => {
                      const activeSelection =
                        selectedTabForUser === "Staff"
                          ? selectedStaffRows
                          : selectedProviderRows;
                      if (activeSelection.length === 0) return null;
                      return (
                        <Button
                          label={`Send Invitation${
                            activeSelection.length > 1
                              ? ` (${activeSelection.length})`
                              : ""
                          }`}
                          variant="contained"
                          onClickCb={() => {
                            const ids = activeSelection.map((r: any) => r?.id);
                            dispatch(sendFacilityUserBulkInvitation({ ids }));
                          }}
                          style={commonButtonStyle}
                        ></Button>
                      );
                    })()}

                    {/* IMPORT USERS BUTTON */}
                    <Button
                      startIcon={
                        <img
                          src={DownloadIcon}
                          alt={"import"}
                          className="cursor-pointer w-[19px] h-[19px]"
                        />
                      }
                      label="Import Users"
                      variant="outlined"
                      onClickCb={() => setOpenImportUsersDialog(true)}
                      style={{
                        ...commonButtonStyle,
                        backgroundColor: "white",
                        border: "1px solid #005596",
                        color: "#005596",
                      }}
                    ></Button>

                    {/* ADD Add STAFF BUTTON */}
                    {
                      <Button
                        startIcon={
                          <img
                            style={{ height: "23px" }}
                            src={plusIcon}
                            alt={"search"}
                            className="cursor-pointer w-[18px] h-[18px]"
                          />
                        }
                        label={
                          selectedTabForUser === "Staff"
                            ? "Add Staff User"
                            : "Add Provider User"
                        }
                        variant="contained"
                        onClickCb={() => {
                          {
                            setOpenAddProviderProfileDialog(true);
                            setDefaultDataForUser({});
                          }
                        }}
                        style={commonButtonStyle}
                      ></Button>
                    }
                  </div>
                </div>

                {selectedTabForUser === "Provider" && (
                  <Table
                    columns={userProviderTabColumns}
                    rows={userProviderTabRowData}
                    selectProps={{
                      isSelectAll: true,
                      isSelectable: true,
                      onSelectRowsCb: setSelectedProviderRows,
                      selectIdentifier: "id",
                      onSelectAll: () => {},
                    }}
                    paginationProps={{
                      isPagination: true,
                      page: pageNumber,
                      totalPages: facilityUserList?.totalPages,
                      totalCount: facilityUserList?.total,
                      limit: rowPerPage,
                      rowsPerPageOptions: [10, 25, 50],
                      onPageChange: (page: any) => {
                        setPageNumber(page);
                      },
                      handleChangeRowsPerPage: (rowPerPage: any) => {
                        setRowPerPage(rowPerPage);
                        setPageNumber(1);
                      },
                    }}
                  />
                )}
                {selectedTabForUser === "Staff" && (
                  <Table
                    columns={userStaffTabColumns}
                    rows={userStaffTabRowData}
                    selectProps={{
                      isSelectAll: true,
                      isSelectable: true,
                      onSelectRowsCb: setSelectedStaffRows,
                      selectIdentifier: "id",
                      onSelectAll: () => {},
                    }}
                    paginationProps={{
                      isPagination: true,
                      page: pageNumber,
                      totalPages: facilityUserList?.totalPages,
                      totalCount: facilityUserList?.total,
                      limit: rowPerPage,
                      rowsPerPageOptions: [10, 25, 50],
                      onPageChange: (page: any) => {
                        setPageNumber(page);
                      },
                      handleChangeRowsPerPage: (rowPerPage: any) => {
                        setRowPerPage(rowPerPage);
                        setPageNumber(1);
                      },
                    }}
                  />
                )}
              </div>
            )}

            {/* IF SELECTED TAB IS ROOM */}
            {selectedTab === "room" && (
              <div className="mt-6 tab-main-content-height">
                <div className="flex flex-wrap items-center mb-4 gap-3 w-full xl:w-auto xl:justify-end">
                  {/* SEARCH DROPDOWN */}
                  {/* Width comes from MUI sx inside the component, so size it here. */}
                  <div className="w-full sm:w-[300px]">
                    <SearchSelectDropdown
                      freeSolo={true}
                      searchedValue={searchedValue}
                      onSearchValueChangeCb={(e) => handleChange(e)}
                      size="small"
                      label="Search by room name"
                      fullWidth="100%"
                      startIcon={
                        <img
                          alt="search-icon"
                          src={searchIcon}
                          width={"18px"}
                          height={"18px"}
                        />
                      }
                    />
                  </div>
                  {/* ADD ROOM BUTTON */}
                  <Button
                    startIcon={
                      <img
                        style={{ height: "23px" }}
                        src={plusIcon}
                        alt={"add"}
                        className="cursor-pointer w-[19px] h-[19px]"
                      />
                    }
                    label="Add Room"
                    variant="contained"
                    onClickCb={() => {
                      setDefaultRoomDataRow({});
                      setOpenAddNewRoomDialog(true);
                    }}
                    style={commonButtonStyle}
                  ></Button>
                </div>
                <Table
                  columns={roomTabColumns}
                  rows={roomTabRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalPages: roomList?.totalPages,
                    totalCount: roomList?.total,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* OPEN ADD DEPARTMENT DIALOG */}
      {openAddNewDepartmentDialog && (
        <AddDepartmentDialog
          defaultDepartmentDataRow={defaultDepartmentDataRow}
          dialogHeading={
            defaultDepartmentDataRow?.departmentId
              ? "Edit Department"
              : "Add New Department"
          }
          isOpen={openAddNewDepartmentDialog}
          handleClose={() => setOpenAddNewDepartmentDialog(false)}
          handleData={(data) => {
            handleAddDepartmentData(data);
          }}
        />
      )}

      {/* OPEN ADD ROOM DIALOG */}
      {openAddNewRoomDialog && (
        <AddNewRoomDialog
          defaultRoomDataRow={defaultRoomDataRow}
          dialogHeading={defaultRoomDataRow?.id ? "Edit Room" : "Add New Room"}
          isOpen={openAddNewRoomDialog}
          handleClose={() => setOpenAddNewRoomDialog(false)}
          handleData={(data) => {
            handleAddRoomData(data);
          }}
        />
      )}

      {/* DELETE ROOM CONFIRMATION */}
      {openDeleteInventoryConfirmation && (
        <EventEHRConfirmationDialog
          alertTitle="Delete Inventory"
          alertDescription={`Are you sure you want to delete "${selectedInventoryToDelete?.itemName}"? This action cannot be undone.`}
          cancelButtonTitle="Cancel"
          submitButtonTitle="Delete"
          open={openDeleteInventoryConfirmation}
          handleClose={(action) => {
            if (action === "close") {
              setOpenDeleteInventoryConfirmation(false);
              setSelectedInventoryToDelete(null);
            } else if (action === "submit") {
              if (selectedInventoryToDelete?.id) {
                dispatch(
                  deleteFacilityInventory({
                    id: selectedInventoryToDelete?.id,
                  }),
                );
              }
              setOpenDeleteInventoryConfirmation(false);
              setSelectedInventoryToDelete(null);
            }
          }}
        />
      )}

      {openDeleteRoomConfirmation && (
        <EventEHRConfirmationDialog
          alertTitle="Delete Room"
          alertDescription="Are you sure you want to delete this room? Please confirm to proceed."
          cancelButtonTitle="Cancel"
          submitButtonTitle="Delete"
          open={openDeleteRoomConfirmation}
          handleClose={(action) => {
            if (action === "close") {
              setOpenDeleteRoomConfirmation(false);
              setSelectedRoomToDelete(null);
            } else if (action === "submit") {
              if (selectedRoomToDelete?.id) {
                dispatch(deleteRoom({ roomId: selectedRoomToDelete?.id }));
              }
              setOpenDeleteRoomConfirmation(false);
              setSelectedRoomToDelete(null);
            }
          }}
        />
      )}

      {/* OPEN ADD PATIENT DIALOG */}
      {openAddNewPatientDialog && (
        <AddNewPatientDialog
          isOpen={openAddNewPatientDialog}
          handleClose={() => setOpenAddNewPatientDialog(false)}
          handlePatientFieldsData={() => {}}
        />
      )}

      {/* OPEN ADD NEW INVENTORY DIALOG */}
      {openAddNewInventoryDialog && (
        <AddNewInventoryDialog
          check={check}
          defaultInventoryData={defaultInventoryData}
          isOpen={openAddNewInventoryDialog}
          dialogHeading={
            defaultInventoryData?.id ? "Re-Order Inventory" : "Add Inventory"
          }
          handleClose={() => {
            setOpenAddNewInventoryDialog(false);
          }}
          handleData={(data) => {
            handleFacilityInventoryData(data);
          }}
        />
      )}

      {/* OPEN IMPORT INVENTORY DIALOG */}
      {openImportInventoryDialog && (
        <ImportInventoryDialog
          dialogHeading="Import Inventory"
          isOpen={openImportInventoryDialog}
          handleClose={() => setOpenImportInventoryDialog(false)}
          handleImportInventoryData={(formData: Record<string, unknown>) => {
            handleImportFacilityData(formData);
          }}
          isImporting={isImporting}
          importMessage={importMessage}
        />
      )}

      {/* IMPORT RESULTS DIALOG */}
      <ImportResultsDialog
        isOpen={openImportResultsDialog}
        handleClose={() => {
          setOpenImportResultsDialog(false);
          setImportResults(null);
        }}
        results={importResults}
      />

      {/* OPEN IMPORT USERS DIALOG */}
      {openImportUsersDialog && (
        <ImportUsersDialog
          isOpen={openImportUsersDialog}
          handleClose={() => {
            setOpenImportUsersDialog(false);
            setImportUsersMessage(null);
          }}
          handleImportUsersData={(formData: Record<string, unknown>) => {
            handleImportUsersData(formData);
          }}
          isImporting={isImportingUsers}
          importMessage={importUsersMessage}
        />
      )}

      {/* IMPORT USERS RESULTS DIALOG */}
      <ImportResultsDialog
        isOpen={openImportUsersResultsDialog}
        handleClose={() => {
          setOpenImportUsersResultsDialog(false);
          setImportUsersResults(null);
        }}
        results={importUsersResults}
        invalidColumns={importUsersResultsColumns}
      />

      {/*OPEN VIEW PATIENT LIST*/}
      {openPatientListDialog?.isOpen && (
        <ViewFacilityPatientDialog
          dialogHeading="View Patient Details"
          handleClose={() =>
            setOpenPatientListDialog({ isOpen: false, defaultData: {} })
          }
          defaultDataForPatientList={openPatientListDialog?.defaultData}
          isOpen={openPatientListDialog?.isOpen}
        />
      )}
      {/*OPEN VIEW INVENTORY LIST*/}
      {openViewInventoryListDialog && (
        <ViewFacilityInventoryDialog
          dialogHeading="View Inventory Details"
          handleClose={() => {
            setOpenViewInventoryListDialog(false);
            dispatch(setGroupedNotesData([]));
          }}
          defaultDataForInventoryList={defaultDataForViewInventoryList}
          groupedNotes={groupedNotesData}
          isOpen={openViewInventoryListDialog}
        />
      )}

      {/* ADJUST INVENTORY DIALOG */}
      {openAdjustDialog && (
        <AdjustInventoryDialog
          isOpen={openAdjustDialog}
          dialogHeading="Adjust Inventory"
          defaultDataForInventory={defaultDataForAdjust}
          handleClose={() => setOpenAdjustDialog(false)}
          handleData={(data) => adjustNotesHandler(data)}
        />
      )}

      {/* SEND / TRANSFER INVENTORY DIALOG (single + bulk) */}
      {openSendDialog && (
        <SendInventoryDialog
          isOpen={openSendDialog}
          dialogHeading={
            isSingleTransfer ? "Send Inventory" : "Send Bulk Inventory"
          }
          selectedItems={transferItems}
          hideTable={isSingleTransfer}
          currentFacilityId={facilityId}
          handleClose={() => setOpenSendDialog(false)}
          handleSend={(data) => handleTransferSend(data)}
        />
      )}

      {/* OPEN ADD PATIENT DIALOG */}
      <AddProviderUserDialog
        isOpen={openAddProviderUserDialog}
        handleClose={() => setOpenAddProviderUserDialog(false)}
        handleData={() => {}}
      />

      {openAddProviderProfileDialog && (
        <ProviderProfileDialog
          //   isEdit={true} //for edit dialog
          dialogHeading={headingTitle}
          defaultDataForUser={defaultDataForUser}
          selectedTabForUser={selectedTabForUser}
          departmentName={baseCampDetails?.facility?.name}
          isOpen={openAddProviderProfileDialog}
          handleClose={() => setOpenAddProviderProfileDialog(false)}
          handleData={(data: Record<string, unknown>) => {
            handleAddProviderUser(data);
          }}
        />
      )}

      {openViewUserDialog && (
        <UserViewDialog
          selectedTabForUser={selectedTabForUser}
          departmentName={baseCampDetails?.facility?.name}
          dialogHeading={headingTitleForView}
          handleClose={() => setOpenViewUserDialog(false)}
          defaultDataForUser={defaultDataForUser}
          isOpen={openViewUserDialog}
        />
      )}

      {openConfirmationDialog && (
        <EventEHRConfirmationDialog
          alertTitle={`Delete ${selectedTabForUser}`}
          alertDescription={`Are you sure you want to delete this ${selectedTabForUser}? Please confirm to proceed.`}
          cancelButtonTitle="Cancel"
          submitButtonTitle="Delete"
          open={openConfirmationDialog}
          handleClose={(action) => {
            if (action === "close") {
              setOpenConfirmationDialog(false);
              setSelectedUserId(null);
            } else if (action === "submit") {
              if (selectedUserId) {
                const payload = {
                  id: selectedUserId,
                };
                dispatch(deleteFacilityUser(payload));
              }
            }
          }}
        />
      )}

      {openDeleteDepartmentConfirmationDialog && (
        <DeleteFacilityConfirmationDialog
          isOpen={openDeleteDepartmentConfirmationDialog}
          dialogHeading="Delete Department"
          handleClose={handleDeleteDepartmentConfirmation}
          facilityName={
            deleteDepartmentData?.departmentName ||
            deleteDepartmentResponseData?.department?.name
          }
          relatedData={deleteDepartmentResponseData?.relatedData}
          warning={deleteDepartmentResponseData?.warning}
          message={deleteDepartmentResponseData?.message}
        />
      )}
    </WrapperCard>
  );
};

export default FacilityDetailsScreen;
